import i18next from "i18next";

export default class FormatUtil {

    public static formatCurrency = (currency: string, amount: number | null, language?: string): string => {
        if (amount == null) {
            return '-';
        }
        const currencyFormatter = Intl.NumberFormat(language ? language : i18next.language, {
            style: 'currency',
            currency: currency
        });
        return currencyFormatter.format(amount);
    }

    public static formatPercentage = (percentage: number, minimumFractionDigits: number, language?: string): string => {
        if (percentage == null || Number.isNaN(percentage)) {
            return '-';
        }

        const percentageFormatter = Intl.NumberFormat(language ? language : i18next.language, {
            style: 'percent',
            minimumFractionDigits: minimumFractionDigits,
        })
        return percentageFormatter.format(percentage);
    }

    public static formatInput = (input: string, language?: string): string => {
        let thousandSeparator = Intl.NumberFormat(language ? language : i18next.language).format(11111).replace(/\p{Number}/gu, '');
        let decimalSeparator = Intl.NumberFormat(language ? language : i18next.language).format(1.1).replace(/\p{Number}/gu, '');

        return input.replace(new RegExp('\\' + thousandSeparator, 'g'), '')
            .replace(new RegExp('\\' + decimalSeparator, 'g'), '.');
    }

    public static formatNumberDisplay = (amount: number | undefined | null, language?: string): string => {
        if (amount == null) {
            return '';
        }
        return Intl.NumberFormat(language ? language : i18next.language).format(amount);
    }
}
